import { websocketActions } from '../../../../app/middleware/websocket/actions/websocket';
const initialState = {
    meta: {
        asyncStatus: 'succeeded',
        featureflagsAsyncStatus: 'succeeded',
        hasUnsavedChanges: false,
    },
    organization: {
        name: '',
        avatar_url: '',
        id: '',
        created_at: '',
        trial_ended_at: null,
        subdomain: '',
        suspended: false,
        default_queue: '',
        default_outbound_number: null,
        elevio_workspace_id: null,
    },
    featureflags: {
        is_listen_in_allowed: true,
        is_callrecording_allowed: true,
    },
};
export function organization(state = initialState, action) {
    switch (action.type) {
        case websocketActions.createFulfilled.type:
            return Object.assign(Object.assign({}, state), { organization: action.payload.params.organization });
        case 'ORGANIZATION_GET_SUCCEEDED':
            return Object.assign(Object.assign({}, state), { organization: action.organization, meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded' }) });
        case 'ORGANIZATION_GET_FAILED':
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
        case 'ORGANIZATION_GET_FEATURE_FLAGS':
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { featureflagsAsyncStatus: 'loading' }) });
        case 'ORGANIZATION_GET_FEATURE_FLAGS_SUCCEEDED':
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { featureflagsAsyncStatus: 'succeeded' }), featureflags: Object.assign({}, action.featureflags ? action.featureflags : state.featureflags) });
        case 'ORGANIZATION_GET_FEATURE_FLAGS_FAILED':
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { featureflagsAsyncStatus: 'failed' }) });
        case 'ORGANIZATION_EDIT':
        case 'ORGANIZATION_GET_PRESIGNED':
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'loading' }) });
        case 'ORGANIZATION_EDIT_SUCCEEDED':
            return Object.assign(Object.assign({}, state), { organization: Object.assign(Object.assign({}, state.organization), action.organization), meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'succeeded', hasUnsavedChanges: false }) });
        case 'ORGANIZATION_UPLOAD_AVATAR_SUCCEEDED':
            return Object.assign(Object.assign({}, state), { organization: Object.assign(Object.assign({}, state.organization), { avatar_url: action.payload.updates.avatar_url }) });
        case 'ORGANIZATION_EDIT_FAILED':
        case 'ORGANIZATION_UPLOAD_AVATAR_FAILED':
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { asyncStatus: 'failed' }) });
        case 'ORGANIZATION_CHANGE_DEFAULT_NUMBER':
            return Object.assign(Object.assign({}, state), { organization: Object.assign(Object.assign({}, state.organization), { default_outbound_number: action.defaultNumber }), meta: Object.assign(Object.assign({}, state.meta), { hasUnsavedChanges: true }) });
        default:
            return state;
    }
}
